import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { ActingDetailQueryResponse } from '@area-restrita/api-client/model/actingDetailQueryResponse';

import PageContainer from '@/components/layout/PageContainer';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

import ActingChecklist from './ActingChecklist';
import ActingRouteAnalysisCard from './ActingRouteAnalysisCard';
import ActingRouteMap from './ActingRouteMap';
import ActingSummary from './ActingSummary';

interface IProps {
  acting: ActingDetailQueryResponse;
  refreshFailed: boolean;
}

const ActingDetailsView: React.FC<IProps> = ({ acting, refreshFailed }) => (
  <PageContainer title="Detalhes da Execução">
    <div className="flex flex-col gap-6">
      {refreshFailed && (
        <Alert variant="destructive">
          <AlertTriangleIcon />
          <AlertTitle>Atualização interrompida</AlertTitle>
          <AlertDescription>
            Os últimos dados carregados permanecem visíveis. Uma nova tentativa
            será feita automaticamente.
          </AlertDescription>
        </Alert>
      )}
      <ActingSummary acting={acting} />
      <ActingRouteMap key={acting.id} acting={acting} />
      <ActingRouteAnalysisCard routeComparison={acting.routeComparison} />
      <ActingChecklist acting={acting} />
    </div>
  </PageContainer>
);

export default ActingDetailsView;
